export default "__VITE_ASSET__BBakf1AI__"